import { useMemo, useState } from 'react'
// api
import { useGetActiveAlarmsQuery, AlarmDetailsDto, isAcknowledged, sort as alarmSort } from '../../services/alarm'

interface UseActiveAlarmsOutput {
    count: number,
    items: AlarmDetailsDto[] | undefined,
    error: any,
    isLoading: boolean,
    isSuccess: boolean
}


function useActiveAlarms(): UseActiveAlarmsOutput {

    const { data: alarms, error, isLoading, isSuccess, currentData } = useGetActiveAlarmsQuery({}, { refetchOnFocus: true, pollingInterval: 60*1000, refetchOnReconnect: true})

    const sortedAlarms = useMemo(() => {
        const tmp = alarms?.slice()
        return tmp?.sort((a, b) => alarmSort(a, b))
    }, [alarms]);


    return {
        count: sortedAlarms?.length || 0,
        items: sortedAlarms,
        error: error,
        isLoading: isLoading,
        isSuccess: isSuccess,
    }
}

export default useActiveAlarms